/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const InstallationWizardCompletedStep = {
    None: 'None',
    Database: 'Database',
    SiteName: 'SiteName',
    Email: 'Email',
    User: 'User'
} as const;
export type InstallationWizardCompletedStep = typeof InstallationWizardCompletedStep[keyof typeof InstallationWizardCompletedStep];


export function InstallationWizardCompletedStepFromJSON(json: any): InstallationWizardCompletedStep {
    return InstallationWizardCompletedStepFromJSONTyped(json, false);
}

export function InstallationWizardCompletedStepFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstallationWizardCompletedStep {
    return json as InstallationWizardCompletedStep;
}

export function InstallationWizardCompletedStepToJSON(value?: InstallationWizardCompletedStep | null): any {
    return value as any;
}

/**
 * Check if a given object implements the InstallationWizardCompletedStep interface.
 */
 export function instanceOfInstallationWizardCompletedStep(value: any): value is InstallationWizardCompletedStep {
    return Object.values(InstallationWizardCompletedStep).includes(value)
}

